export default [
    {
        path: 'procedimento-individualizado',
        component: () => import(/* webpackChunkName: 'bpa-procedimento-individualizado' */ '@/views/bpa/procedimento-individualizado/Index'),
        redirect: 'procedimento-individualizado/index',
        children: [
            {
                name: 'bpa-procedimento-individualizado-index',
                path: 'index',
                component: () => import(/* webpackChunkName: 'bpa-procedimento-individualizado' */ '@/views/bpa/procedimento-individualizado/List.vue'),
            },
            {
                name: 'bpa-procedimento-individualizado-create',
                path: 'create',
                component: () => import(/* webpackChunkName: 'bpa-procedimento-individualizado' */ '@/views/bpa/procedimento-individualizado/Form.vue'),
            },
            {
                name: 'bpa-procedimento-individualizado-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(/* webpackChunkName: 'bpa-procedimento-individualizado' */ '@/views/bpa/procedimento-individualizado/Form.vue'),
            },
        ],
    },
]